var exports = {
  "modalBackdrop": "Modal.module__modalBackdrop___ZUt4WU",
  "layer": "Modal.module__layer___ZUt4WU",
  "backdropSlot": "Modal.module__backdropSlot___ZUt4WU",
  "positionAbsoluteInsetZero": "Modal.module__positionAbsoluteInsetZero___ZUt4WU",
  "backdropCentered": "Modal.module__backdropCentered___ZUt4WU",
  "focusLock": "Modal.module__focusLock___ZUt4WU",
  "surface": "Modal.module__surface___ZUt4WU",
  "layerFullscreen": "Modal.module__layerFullscreen___ZUt4WU",
  "layerFullscreenMobile": "Modal.module__layerFullscreenMobile___ZUt4WU",
  "layerCentered": "Modal.module__layerCentered___ZUt4WU",
  "root": "Modal.module__root___ZUt4WU",
  "centeredOnMobile": "Modal.module__centeredOnMobile___ZUt4WU",
  "rootAnimating": "Modal.module__rootAnimating___ZUt4WU",
  "medium": "Modal.module__medium___ZUt4WU",
  "small": "Modal.module__small___ZUt4WU",
  "footer": "Modal.module__footer___ZUt4WU",
  "formFooter": "Modal.module__formFooter___ZUt4WU",
  "large": "Modal.module__large___ZUt4WU",
  "xlarge": "Modal.module__xlarge___ZUt4WU",
  "fullscreen": "Modal.module__fullscreen___ZUt4WU",
  "layout": "Modal.module__layout___ZUt4WU",
  "header": "Modal.module__header___ZUt4WU",
  "light": "Modal.module__light___ZUt4WU",
  "dark": "Modal.module__dark___ZUt4WU",
  "stretchButtons": "Modal.module__stretchButtons___ZUt4WU",
  "headerInner": "Modal.module__headerInner___ZUt4WU",
  "headerText": "Modal.module__headerText___ZUt4WU",
  "content": "Modal.module__content___ZUt4WU",
  "contentNoPadding": "Modal.module__contentNoPadding___ZUt4WU",
  "screenReaderLabel": "Modal.module__screenReaderLabel___ZUt4WU",
  "insetCloseButtonContainer": "Modal.module__insetCloseButtonContainer___ZUt4WU",
  "insetCloseButton": "Modal.module__insetCloseButton___ZUt4WU",
  "contentLayout": "Modal.module__contentLayout___ZUt4WU",
  "description": "Modal.module__description___ZUt4WU",
  "inputGroup": "Modal.module__inputGroup___ZUt4WU",
};

__webpack_require__.r(module.exports = exports);
